import React, { useEffect, useState, useContext, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Editor from "../../../Pages/Editor/Editor";
import CoverEditor from "../../../Pages/CoverEditor/Editor";
import "./AddSectionModal.scss";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import SectionItem from "../../../Components/Editor/SectionItem";
import DummySection from "../../DummySectionComponents/DummySection";

// import { onmessage } from "../../../workers/preview-worker";

function AddSections({
  showAddSection,
  setShowAddSection,
  availableSection,
  sectionType,
  setSection,
  checkSectionPresentOrNot,
}) {
  const handleClose = () => {
    setShowAddSection(false);
  };

  const handleSectionClick = (section) => {
    setSection(section, "sectionType");
    handleClose();
  };

  return (
    <>
      <Modal
        className="add-resume-section-modal"
        show={showAddSection}
        size="lg"
        centered
        aria-labelledby="contained-modal-title-vcenter"
        onEscapeKeyDown={() => handleClose()}
        onHide={() => handleClose()}
      >
        <Modal.Body className="">
          <img
            onClick={() => handleClose()}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="text-center">
            <h2>Add new section</h2>
            <p>Click on a section to add it to your resume</p>
          </div>

          <div>
            <div className="row">
              {availableSection.map((sectionData, index) => (
                <SectionItem
                  key={index}
                  sectionData={sectionData}
                  sectionType={sectionType}
                  setSection={setSection}
                  checkSectionPresentOrNot={checkSectionPresentOrNot}
                  handleClose={handleClose}
                />
              ))}
              <>
                <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                  <div
                    className="d-flex justify-content-between w-100 cursor mb-2"
                    // onClick={(e) => handleSectionClick()}
                  >
                    <DummySection
                      sectionId={"customDate"}
                      sectionName={"Custom Date"}
                      handleSectionClick={() =>
                        handleSectionClick("customDate")
                      }
                    />
                  </div>
                </div>
              </>
              <>
                <div className="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
                  <div className="d-flex justify-content-between w-100 cursor mb-2">
                    <DummySection
                      sectionId={"customText"}
                      sectionName={"Custom Text"}
                      handleSectionClick={() =>
                        handleSectionClick("customText")
                      }
                    />
                  </div>
                </div>
              </>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AddSections;
